import { useNavigate, useSearchParams } from "react-router-dom";
import { urls } from "../../../../../urls";
import { type PublicEventStep, type WizardStep } from "../wizardSteps";

export const useStepNavigation = (eventId: string, steps: ReadonlyArray<WizardStep>) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: PublicEventStep = steps.some((s) => s.key === rawStep)
    ? (rawStep as PublicEventStep)
    : steps[0].key;

  const navigateToStep = (step: PublicEventStep) => {
    navigate(urls.v2.sourcingEvents.edit.go(eventId)[step]);
  };

  return { currentStep, navigateToStep };
};
